import './CustomDownloadToast.scss';

import IconButton from '@material-ui/core/IconButton';
import React from 'react';

import { DownloadOptions } from '../../../../Core/Services/Interfaces/IToastService';
import iconInfo from '../../../assets/icons/toast/info.svg';
import iconError from '../../../assets/icons/toast/error.svg';
import iconSuccess from '../../../assets/icons/toast/success.svg';
import { IconClose } from '../Icons/Icons';
import { Debugger } from '../../../../Core/Errors/Debugger';
import classNames from 'classnames';

interface CustomDownloadToastProps {
    downloadOptions: DownloadOptions;
}

const CustomDownloadToast = ({ downloadOptions }: CustomDownloadToastProps) => {
    const { fileName, content, success, failed } = downloadOptions;

    Debugger.LogValue(`🔥🔥🔥🔥🔥 | ${fileName}`, content);

    const classname = classNames({
        'custom-toast-container': true,
        success: success ? true : false,
        error: failed ? true : false,
    });

    const toastContent = ({ closeToast }: any) => {
        return (
            <div className={classname}>
                {!success && !failed ? (
                    <img src={iconInfo} alt="info" className="toast-icon" />
                ) : undefined}
                {failed ? <img src={iconError} alt="error" className="toast-icon" /> : undefined}
                {success ? (
                    <img src={iconSuccess} alt="success" className="toast-icon" />
                ) : undefined}
                <div className="body">
                    <div>
                        <div className="title">{fileName}</div>
                        <div className="content">{content}</div>
                    </div>
                    <IconButton className="close-icon" onClick={closeToast} children={IconClose} />
                </div>
            </div>
        );
    };

    return toastContent;
};

export { CustomDownloadToast };
